<script>
  import { getContext } from 'svelte'
  import { cssPrefix } from '../helper-classes.js'

  export let config = null

  const layout = config.layout || getContext('formGroupLayout')
  if (layout === 'TwoCols') {
    config.blockClasses = [`${cssPrefix}form-block`, 'is-horizontal']
  } else {
    config.blockClasses = [`${cssPrefix}form-block`]
  }
</script>

<div class={config.blockClasses && config.blockClasses.join(' ')}>
  <div class={`${cssPrefix}form-label`}>
    <!-- Empty -->
  </div>

  <div class={`${cssPrefix}form-field`}>
    <slot />
  </div>
</div>
